export default __webpack_public_path__ + "static/media/featureRaceHomeMobile.6ee09fdb.png";